const ImageRemove01Icon = /*#__PURE__*/ [
  ["path", { d: "M11.5 3C7.02166 3 4.78249 3 3.39124 4.39124C2 5.78249 2 8.02166 2 12.5C2 16.9783 2 19.2175 3.39124 20.6088C4.78249 22 7.02166 22 11.5 22C15.9783 22 18.2175 22 19.6088 20.6088C21 19.2175 21 16.9783 21 12.5C21 12.1715 21 11.855 20.9995 11.55", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 21C9.20998 16.2487 13.9412 9.9475 21 14.6734", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 6H14", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export { ImageRemove01Icon as default };
//# sourceMappingURL=ImageRemove01Icon.js.map
